module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-1280x160-a89da08a4af26eb3b8ce01e2f18d8ea3.webp";